import './catcher-throwing/table'
import './catcher-throwing/visual/main'
